import React from 'react';
import Auth0LockPlayground from 'auth0-lock-playground';

const settings = {
  defaultsLogosBaseUrl: 'https://cdn2.auth0.com/website/playground/'
};
const LockPlayground = () => <Auth0LockPlayground {...settings} />;

export default LockPlayground;



// WEBPACK FOOTER //
// ./src/components/LockPlayground/LockPlayground.js